// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__SABqE","logo":"Header_logo__lzQjV","logo-text":"Header_logo-text__wFX8h","mail":"Header_mail__k1An5"};